import { Ability } from 'ember-can';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import _intersection from 'lodash/intersection';

import { GLOBAL_ADMIN, LOCATION_ADMIN } from 'garaje/utils/roles';

const ALLOWED_ROLES = [GLOBAL_ADMIN, LOCATION_ADMIN];

export default class IdentityVerificationAbility extends Ability {
  @service currentAdmin;
  @service state;

  get canApprove() {
    return this.canReview;
  }

  get canDeny() {
    return this.canReview;
  }

  get canConfigure() {
    const { roleNames } = this.currentAdmin;
    return isPresent(_intersection(ALLOWED_ROLES, roleNames));
  }

  get canReview() {
    const { roleNames } = this.currentAdmin;
    const blocklistContacts = get(this.state, 'currentLocation.blocklistContacts') || [];
    const isSecurityContact = !!blocklistContacts.findBy('id', this.currentAdmin.id);

    return isPresent(_intersection(ALLOWED_ROLES, roleNames)) || isSecurityContact;
  }
}
